import React from 'react';
import { CskhHeaderIcon } from '@assets/icon';
import './CskhMessageToast.scss';

export interface CskhMessageToastData {
  id?: string;
  text: string;
  title?: string;
  timeLabel?: string;
}

interface CskhMessageToastProps {
  message: CskhMessageToastData | null;
  onClick?: () => void;
}

const CskhMessageToast: React.FC<CskhMessageToastProps> = ({ message, onClick }) => {
  if (!message) return null;

  return (
    <button
      key={message.id}
      type="button"
      className="cskh-message-toast"
      onClick={onClick}
    >
      <span className="cskh-message-toast__avatar" aria-hidden>
        <CskhHeaderIcon width={40} height={40} className="w-10 h-10" />
      </span>
      <span className="cskh-message-toast__body">
        <span className="cskh-message-toast__header">
          <span className="cskh-message-toast__title">
            {message.title || 'Chăm sóc khách hàng'}
          </span>
          <span className="cskh-message-toast__time">
            {message.timeLabel || 'bây giờ'}
          </span>
        </span>
        <span className="cskh-message-toast__preview">{message.text}</span>
      </span>
    </button>
  );
};

export default CskhMessageToast;
